module.exports = __webpack_public_path__ + "static/sport_w_polskim_radiu-cd2231773f9f1848c89ac842bacfd5af.jpg";